<template>
  <div>
    <div class="d1 lp">
      内容神器根据您当前文章内容，智能分析出摘要内容<span class="bs"
        ><button @click="use" class="btn1" :disabled="isUse">使用该摘要</button
        ><button
          @click="copy('.btn')"
          :data-clipboard-text="abstract"
          class="btn"
          :disabled="isUse"
        >
          复制
        </button></span
      >
    </div>
    <div class="lp" v-loading="loading">
      <ul>
        <li>
          <span class="lspan">{{ abstract }}</span>
        </li>
      </ul>
    </div>
    <div style="text-align: center;margin: 0 auto;margin-top: 30px;">
      <button class="btn3" @click="getAbstract" v-if="resetCheck">
        重新检测
      </button>
    </div>
  </div>
</template>

<script>
import { SendPostData } from "../../assets/script/model";
import tinymce from "tinymce";
import { mapActions } from "vuex";
import editorControl from "../../assets/script/utils/editorControl";

export default {
  name: "GetAbstract",
  data() {
    return {
      abstract: "",
      loading: false,
      isUse: true,
      resetCheck: false,
      showBoxType: false,
      typeName: ""
    };
  },
  computed: {
    wycAbstract: {
      get() {
        return this.$store.state.wycContent.wycAbstract;
      },
      set(val) {
        this.$store.state.wycContent.wycAbstract = val;
      }
    },
    edAbstract: {
      get() {
        return this.$store.state.wycContent.edAbstract;
      },
      set(val) {
        this.$store.state.wycContent.edAbstract = val;
      }
    },
    wycShow: {
      get() {
        return this.$store.state.contents.wycShow;
      },
      set(val) {
        this.$store.state.contents.wycShow = val;
      }
    },
    showMsg: {
      get() {
        return this.$store.state.wycContent.showMsg;
      },
      set(val) {
        this.$store.state.wycContent.showMsg = val;
      }
    },
    insertHtml: {
      get() {
        return this.$store.state.editorControl.insertHtml;
      },
      set(val) {
        this.$store.state.editorControl.insertHtml = val;
      }
    },
    insertDoc: {
      get() {
        return this.$store.state.editorControl.insertDoc;
      },
      set(val) {
        this.$store.state.editorControl.insertDoc = val;
      }
    }
  },
  mounted() {
    this.listenMessage();
  },
  methods: {
    ...mapActions("api", ["APermission"]),
    listenMessage() {
      this.getAbstract();
      let that = this;
      window.addEventListener("message", function(e) {
        if (e.data && e.data.cmd === "_5118_Response_Message_Content") {
          if (
            !e.data.isclose &&
            (e.data.btn === "abstract" || e.data.btn === "aiabstract")
          ) {
            let getMsg = e.data.data;
            if (!getMsg.ErrorCode) {
              if (getMsg) {
                that.abstract = getMsg.Data.Result;
                that.loading = false;
                that.resetCheck = true;
                that.isUse = false;
              }
            } else {
              that.abstract = getMsg.ErrorMess;
              that.loading = false;
              that.resetCheck = true;
            }
          }
        }
      });
    },
    async getAbstract() {
      let result = await this.APermission({ SysName: "wycabstract" });
      if (result.errorCode > 0) {
        this.isUse = true;
        this.$message({
          message: result.errorMess,
          type: "error",
          showClose: true
        });
        return;
      }
      if (result.data > 0 || result.data === -1) {
        this.isUse = false;
        this.loading = true;
        if (this.wycShow) {
          let sendData = new SendPostData();
          sendData.btn = "abstract";
          this.SendMessage(sendData);
        } else {
          let content = tinymce.activeEditor.getBody().innerText;
          let sendData = new SendPostData();
          sendData.btn = "aiabstract";
          sendData.data = { txt: content };
          this.SendMessage(sendData);
        }
      } else {
        this.isUse = true;
        this.loading = false;
        this.insertConfig.showUpgrade(true, "获取更多使用次数");
      }
    },
    use() {
      if (this.wycShow) {
        editorControl.setWycAbstract(this.abstract, "文章摘要插入成功");
      } else {
        tinymce.activeEditor.focus();
        let content = this.abstract;

        tinymce.activeEditor.selection.setCursorLocation(
          tinymce.activeEditor.getBody().firstChild,
          0
        );
        editorControl.setInnerTxt(content, "文章摘要插入成功");
      }
      const getContent = localStorage.getItem("lastEditorContent");
      if (getContent) {
        this.insertDoc = JSON.parse(getContent);
        this.insertDoc.intro = this.abstract;
        localStorage.setItem(
          "lastEditorContent",
          JSON.stringify(this.insertDoc)
        );
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";
* {
  font-size: 12px;
}
/deep/.el-loading-mask {
  margin-top: 150px;
}
.d1 {
  line-height: 30px;
  margin-top: 5px;
}
.lp {
  padding: 0 18px;
}
.bs {
  float: right;
}
li {
  background-color: @boxback-color;
  line-height: 30px;
  margin: 10px 5px 10px 0px;
  padding-left: 10px;
  border-radius: 5px;
}
.btn {
  background-color: #fff;
  padding: 3px 9px;
  color: #0f58f5;
  border: 1px solid #0f58f5;
  border-radius: 10px;
  cursor: pointer;
  margin-right: 8px;
}
.btn1 {
  .btn;
  color: #fff;
  background-color: #0f58f5;
}
.btn2 {
  background-color: #0f58f5;
  padding: 3px 9px;
  color: #fff;
  border: 1px solid #0f58f5;
  border-radius: 10px;
  cursor: pointer;
  margin-right: 8px;
}
.btn3 {
  .btn2;
  padding: 5px 15px;
  background-color: #167df3;
}
.lspan {
  word-break: normal;
  width: 425px;
  display: block;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow: hidden;
  line-height: inherit;
}
</style>
